<template>
  <fin-data-loader :resolver="loadData">
    <template #content>
      <div class="fin-add-instruments pa-0 ma-0">
        <div v-if="!addToPortfolio">
          <v-row v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                 v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                 class="pb-4 pt-6 d-flex">
            <v-col>
              <h1 :class="{'mb-4': $vuetify.breakpoint.xl}"> {{ assetClass.name }} hinzufügen </h1>
            </v-col>
          </v-row>

          <fin-add-to-watchlist v-if="!isWatchlist"
                                :addToWatchlist="addToWatchlist"
                                :selected-instruments="selectedInstruments"
                                @closeAddToWatchlist="addToWatchlist = false"
          />

          <v-row v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
                 v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
                 class="fin-color-primary-light">
            <v-col v-if="!isWatchlist" :align="$vuetify.breakpoint.smAndDown ? 'left': 'center'" class="pt-6" cols="12">
              <p>Du kannst Wertpapiere über eine Strategie oder über das Suchfeld auswählen.</p>
            </v-col>
            <v-col>
              <v-row :class="$vuetify.breakpoint.smAndDown ?'pb-0': 'pb-4'">
                <template v-if="selectedInstruments.length > 0 && showNbOfSelectedItems === true">
                  <v-col
                    v-if="$vuetify.breakpoint.mdAndUp"
                    class="d-flex ">
                    <p class="ma-0 nb-of-assets">
                      <v-btn icon @click="showNbOfSelectedItems = false">
                        <v-icon style="font-size:20px">icon-close</v-icon>
                      </v-btn>
                      {{ selectedInstruments.length }} {{ selectedInstruments.length > 1 ? 'Assets' : 'Asset' }}
                      ausgewählt
                    </p>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12': '3' "
                         class="d-flex justify-end">

                    <v-btn class="mr-2"
                           dark
                           tile
                           @click="!isWatchlist ? (addToPortfolio = true) : addTableSelectionToWatchlist()">
                      <v-icon v-if="isWatchlist" class="ml-n1 mr-2">icon-eye</v-icon>
                      {{ !isWatchlist ? btnTextAddToPortfolio : btnTextAddToWatchlist }}
                    </v-btn>

                    <v-menu :offset-y="true"
                            bottom>
                      <template #activator="{ on }">
                        <v-btn v-on="on" outlined icon tile>
                          <v-icon>icon-contextmenu</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item>
                          <v-list-item-title>
                            <v-btn class="pl-0"
                                   @click="!isWatchlist ? (addToWatchlist = true) : (addToPortfolio = true)"
                                   text>
                              <v-icon v-if="!isWatchlist" class="ml-n1 mr-2">icon-eye</v-icon>
                              {{ !isWatchlist ? btnTextAddToWatchlist : btnTextAddToPortfolio }}
                            </v-btn>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                  <v-col v-if="$vuetify.breakpoint.smAndDown"
                         class="pb-0">
                    <p class="ma-0 nb-of-assets">
                      <v-btn icon @click="showNbOfSelectedItems = false">
                        <v-icon style="font-size:20px">icon-close</v-icon>
                      </v-btn>
                      {{ selectedInstruments.length }} {{ selectedInstruments.length > 1 ? 'Assets' : 'Asset' }}
                      ausgewählt
                    </p>
                  </v-col>
                </template>

                <template v-else>
                  <v-col :cols="$vuetify.breakpoint.smAndDown ? '12': '3' "
                         class="pb-3">
                    <p class="font-weight-bold mb-0">{{ nrOfQualifiedInstruments }} Ergebnisse</p>
                  </v-col>
                  <v-col v-if="!isWatchlist"
                         :class="`pt-0 ${$vuetify.breakpoint.mdAndUp ? 'd-flex justify-end':''}`">
                    <fin-dropdown :items="strategies"
                                  :value="selectedStrategy"
                                  label="Strategie"
                                  output-label-attribute="name"
                                  show-selection
                                  single-select
                                  @input="val => strategyChanged(val)"/>
                    <fin-dropdown v-if="assetClass.id === 'SHARE'"
                                  :items="shareUniverses"
                                  :value="selectedShareUniverse"
                                  label="Index"
                                  output-label-attribute="name"
                                  show-selection
                                  single-select
                                  @input="val => shareUniverseChanged(val)"/>
                    <v-btn :to="{name: assetClass.id === 'SHARE' ? 'shareScreener' : 'etfScreener'}" outlined
                           style="float: right">
                      <span class="pl-2 pr-2"> Screener öffnen </span>
                    </v-btn>
                  </v-col>
                </template>
              </v-row>
              <v-row class="flex-row-reverse">
                <v-col lg="3" md="5" sm="7" xs="12">
                  <fin-assets-name-isin-autocomplete :asset-type="assetClass.id"
                                                     :class="{'ml-4': false}"
                                                     custom-return-item="id isin name assetClass close closeDate latestPrice {price timestamp exchangeName}"
                                                     :custom-search-and-filter="customSearchAndFilter"
                                                     autofocus
                                                     @input="(val) => autocompleteChanged(val)"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <fin-strategy-instruments-data-table
                    v-if="selectedStrategy[0] && selectedStrategy[0].id !== 'NO_STRATEGY' && !isWatchlist"
                    v-model="selectedInstruments"
                    :asset-class-id="assetClass.id"
                    :extended-view="extendedView"
                    :share-universe="selectedShareUniverse"
                    :show-instrument-profile-as="'link'"
                    :show-select="true"
                    :strategy="selectedStrategy[0]"
                    :table-height="$vuetify.breakpoint.smAndDown ? '60vh':'33vh'"
                    :width="$vuetify.breakpoint.lgAndDown ? 'inherit':''"
                    @nbOfQualifiedInstruments="val => nrOfQualifiedInstruments = val"/>
                  <fin-data-table v-else
                                  v-model="selectedInstruments"
                                  :headers="tableHeadersNoStrategy"
                                  :height="540"
                                  :resolver="resolverDataTableNotStrategy"
                                  fixed-header
                                  showSelect
                                  shrinkToViewPort
                                  stickyFirstCol
                                  @nbOfQualifiedInstruments="val => nrOfQualifiedInstruments = val"/>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>

        <div v-if="addToPortfolio" class="fin-screener-add-to-portfolio">
          <fin-add-to-portfolio
            :instruments="selectedStrategy[0] ? selectedStrategyInstruments : selectedInstruments"
            :portfolioId="isWatchlist ? null : id"
            :title="'Wertpapier in Portfolio hinzufügen'"
            :to="{name: 'portfolioDetail', params: {id: id}}"/>
        </div>

      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import FinStrategyInstrumentsDataTable from "@/components/common/StrategyInstrumentsDataTable"
import FinDropdown from "@/components/common/Dropdown"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {listEtfStrategyModels, listShareStrategyModels} from "@/js/finQueries"
import {finEtfAPI, finPortfolioAPI, finShareAPI} from "@/js/finAPI"
import FinAddToWatchlist from "@/components/common/Watchlists/AddToWatchlist"
import FinAssetsNameIsinAutocomplete from "@/components/common/AssetsNameIsinAutocomplete"
import FinAddToPortfolio from "@/components/common/portfolio/AddToPortfolio"
import {TablePresets} from "@/components/common/DataTable/DefaultHeaders"
import FinDataTable from "@/components/common/DataTable/FinDataTable"
import FinDataLoader from "@/components/common/DataLoader"
import AssetClasses from "@/mocks/AssetClasses"
import {EventBus} from "@/plugins/fincraft"

export default {
  name: "fin-add-instruments-to-portfolio",
  components: {
    FinDataLoader,
    FinDataTable,
    FinAddToPortfolio,
    FinAssetsNameIsinAutocomplete,
    FinAddToWatchlist,
    FinDropdown,
    FinStrategyInstrumentsDataTable,
  },
  props: {
    cash: {
      type: Number
    },
    value: {
      type: Array
    },
    // portfolio id automatically set by the routing as this page is defined under portfoliodDetails and props is set to true
    id: {
      type: String
    },
    strategy: {
      type: Object
    },
    // share Universe, only used for asset class SHARE
    shareUniverse: {
      type: Object,
      default: undefined
    },
    assetClassId: {
      type: String
    },
  },
  data() {
    return {
      btnTextAddToPortfolio: 'Zu Portfolio hinzufügen',
      btnTextAddToWatchlist: 'Zu Watchlist hinzufügen',
      selectedInstruments: [],
      showNbOfSelectedItems: true,
      nrOfQualifiedInstruments: 0,
      addToPortfolio: false,
      addToWatchlist: false,
      loadingData: true,
      values: [],
      extendedView: false,
      strategies: [],
      selectedStrategy: [],
      shareUniverses: [],
      selectedShareUniverse: [],
      isWatchlist: false,
      assetClass: AssetClasses.items.find(item => item.id === this.assetClassId),
      resolverDataTableNotStrategy: (options) => this.getTableDataNoStrategy(options)
    }
  },
  computed: {
    tableHeadersNoStrategy() {
      let headers = []

      if (this.assetClassId === 'SHARE') {
        headers = TablePresets.createShareHeaders()
      } else {
        headers = TablePresets.createEtfHeaders()
      }

      return headers
    },
    customSearchAndFilter() {
      let additionalSearchFilter = `{
        restricted: {eq: false},
        active: {eq: true},
        covered: {eq: true},
        delisted: {eq: false},
        `

      if (this.assetClassId.indexOf('ETF') !== -1) {
        additionalSearchFilter += `assetClass: {eq: "${this.assetClassId}"}`
      }
      additionalSearchFilter += `}`
      return additionalSearchFilter
    },
    selectedStrategyInstruments() {
      let res = this.selectedInstruments.map(item => {
        return {
          ...item,
          ...item.instrument
        }
      })
      return res
    }
  },
  methods: {
    async loadData() {
      this.isWatchlist = (this.$route.meta && this.$route.meta.isWatchlist) ? this.$route.meta.isWatchlist : false

      if (!this.isWatchlist) {
        // load the strategies and data specific to the asset class
        if (this.assetClass?.id === 'SHARE') {
          this.strategies = [
            {
              id: 'NO_STRATEGY',
              name: 'Keine Strategie'
            },
            ...(await API.graphql(graphqlOperation(listShareStrategyModels))).data.listShareStrategyModels.items
          ]
          this.shareUniverses = await finPortfolioAPI.searchUniverses()
          this.selectedShareUniverse = this.shareUniverse ? [this.shareUniverse] : [this.shareUniverses[0]]
        } else {
          this.strategies = [
            {
              id: 'NO_STRATEGY',
              name: 'Keine Strategie'
            },
            ...(await API.graphql(graphqlOperation(listEtfStrategyModels))).data.listEtfStrategyModels.items
              .filter(item => item.name.includes(this.assetClass.name.replace("-ETF", '').trim()))
          ]
        }

        this.selectedStrategy = this.strategy ? [this.strategy] : [this.strategies[0]]
      }
    },
    /** method called when no strategy has been selected */
    async getTableDataNoStrategy(options) {
      let {sortBy, sortDesc, page, itemsPerPage} = options
      if (!sortBy || sortBy.length <= 0) {
        sortBy = ["name"]
        sortDesc = [true]
      }
      const params = {
        from: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        sort: sortBy?.length > 0 ? {field: sortBy[0], direction: sortDesc[0] ? 'asc' : 'desc'} : null,
      }

      let shareUniverseFilter = this.buildShareUniverseFilter(this.selectedShareUniverse)
      if (shareUniverseFilter) {
        params.filter = shareUniverseFilter
      }

      let resultSet = undefined
      if (this.assetClassId === 'SHARE') {
        console.log("Calling searchSharesFilteredAndSorted with params", params)
        resultSet = await finShareAPI.searchSharesFilteredAndSorted(params)
      } else {
        params.filter = {assetClass: {eq: this.assetClassId}}
        resultSet = await finEtfAPI.searchEtfs(params)
      }
      this.nrOfQualifiedInstruments = resultSet.total

      return resultSet
    },
    buildShareUniverseFilter(shareUniverse) {
      let selectedUniverse = shareUniverse ? shareUniverse[0] : undefined
      let filter =
        selectedUniverse && selectedUniverse.id === 'OECD' ? {isOECD: {eq: true}} :
          selectedUniverse && selectedUniverse.id === 'BlueChip' ? {isBlueChip: {eq: true}} :
            selectedUniverse && selectedUniverse.id === 'EU' ? {isEU: {eq: true}} :
              selectedUniverse && selectedUniverse.id === 'DE' ? {countryCode: {eq: 'DE'}} :
                undefined
      console.log('shareUniverse filter', filter)
      return filter
    },
    strategyChanged(filteredItems) {
      this.selectedStrategy = [...filteredItems]
    },
    shareUniverseChanged(filteredItems) {
      this.selectedShareUniverse = [...filteredItems]
      console.log("selectedShareUniverse changed", this.selectedShareUniverse)
      this.resolverDataTableNotStrategy = (options) => this.getTableDataNoStrategy(options)
    },
    autocompleteChanged(val) {
      if (val) {
        // watchlist -> directly add it to watchlist
        if (this.isWatchlist) {
          this.addToGivenWatchlist([val])
        }
        // portfolio -> show add to portfolio
        else {
          this.addToPortfolio = true
          this.selectedInstruments = [val]
        }
      }
    },
    addTableSelectionToWatchlist() {
      // watchlist -> directly add it to watchlist
      if (this.isWatchlist) {
        this.addToGivenWatchlist(this.selectedInstruments)
      }
      // portfolio -> show add to watchlist dialog
      else {
        this.addToWatchlist = true
      }
    },
    addToGivenWatchlist(values) {
      EventBus.$emit('addItemsToWatchlist', values)
      this.$router.push({name: 'watchlistDetails', params: {id: this.$route.params.id}})
    }
  }
}
</script>

<style scoped lang="scss">

</style>
